import React from "react";

/**
 * @component LockSmallIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <LockSmallIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const LockSmallIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={12}
      height={12}
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="LockSmallIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M7 0a2 2 0 012 2v1h1a1 1 0 011 1v7a1 1 0 01-1 1H2a1 1 0 01-1-1V4c0-.555.445-1 1-1h1V2a2 2 0 012-2h2zm3 4H2v7h8V4zM7 6v3H5V6h2zm0-5H5a1 1 0 00-.993.883L4 2v1h4V2a1 1 0 00-.883-.993L7 1z"
        fillRule="evenodd"
      />
    </svg>
  )
);
LockSmallIcon.displayName = "LockSmallIcon";
export default LockSmallIcon;
